/*
 * Action Types
 */
export enum AudioTypes {
  GET_AUDIO_REQUEST = '@audio/GET_AUDIO_REQUEST',
  GET_AUDIO_SUCCESS = '@audio/GET_AUDIO_SUCCESS',
  GET_AUDIO_FAILURE = '@audio/GET_AUDIO_FAILURE',

  CREATE_AUDIO_REQUEST = '@audio/CREATE_AUDIO_REQUEST',
  CREATE_AUDIO_SUCCESS = '@audio/CREATE_AUDIO_SUCCESS',
  CREATE_AUDIO_FAILURE = '@audio/CREATE_AUDIO_FAILURE',
}

/*
 * State type
 */
export interface AudioState {
  readonly audioLink: string;
  readonly createdAudioLink: string;
  readonly loading: boolean;
  readonly error: boolean;
}
